export const locationList = [
    { label: "United States", value: "united-states" },
    { label: "Canada", value: "canada" },
    { label: "United Kingdom", value: "united-kingdom" },
    { label: "Australia", value: "australia" },
    { label: "India", value: "india" },
    { label: "Germany", value: "germany" },
    { label: "France", value: "france" },
    { label: "Japan", value: "japan" },
    { label: "China", value: "china" },
    { label: "Brazil", value: "brazil" },
    { label: "Kenya", value: "kenya" },
    { label: "South Africa", value: "south-africa" },
    { label: "Mexico", value: "mexico" },
    { label: "Italy", value: "italy" },
    { label: "Spain", value: "spain" }
  ];
  